// MENU MOBILE *******************************************************************************
/*********************************************************************************************
* Toggle the mobile menu.
	*
*/
const mmMobileMenu = () => {
    if (window.innerWidth > 990) return;

    const elements = {
        header: document.querySelector("header"),
        icon: document.querySelector("[data-header-burger]"),
        mobileMenu: document.querySelector("[data-menu-mobile]"),
        mobileMenuSecondary: document.querySelector("[data-menu-sublinks]"),
        headerMenu: document.querySelector('[data-mm-header]'),
        html: document.querySelector("html")
    };

    const { header, icon, mobileMenu, mobileMenuSecondary, headerMenu, html } = elements;

    const headerHeight = headerMenu.offsetHeight;
    const headerMenuTop = headerMenu.getBoundingClientRect().top;
    const topPosition = `${headerHeight + headerMenuTop}px`;
    const heightCalc = `calc(var(--doc-height) - ${topPosition})`;

    [header, icon, mobileMenu].forEach(el => el.classList.toggle("mm-open"));
    html.classList.toggle("stop-scrolling");

    Object.assign(mobileMenu.style, { top: topPosition, height: heightCalc });

    mobileMenuSecondary.style.height = heightCalc;
};

/*********************************************************************************************
* Close the mobile menu.
	*
*/
const mmCloseMobileMenu = (keepFilterActive = false) => {
    if (window.innerWidth > 990) return;

    const elements = {
        header: document.querySelector("header"),
        icon: document.querySelector("[data-header-burger]"),
        mobileMenu: document.querySelector("[data-menu-mobile]"),
        html: document.querySelector("html")
    };

    if (Object.values(elements).some(el => !el)) return;

    const { header, icon, mobileMenu, html } = elements;

    [header, icon, mobileMenu].forEach(el => el.classList.remove("mm-open"));
    html.classList.remove("stop-scrolling");
}

/*********************************************************************************************
* Set the document height CSS variable to the current window height.
	*
*/
const documentHeight = () => {
    document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

// DROPDOWN **********************************************************************************
/*********************************************************************************************
* Handle dropdown behavior.
	*
*/
const handleDropdown = () => {
    const dropWrappers = document.querySelectorAll('[data-drop]');

    dropWrappers.forEach((item) => {
        const isActive = item.getAttribute('data-drop') === 'dropdown-active';
        const content = item.nextElementSibling;

        if (isActive) {
            item.classList.add('active');
            if (content) content.style.maxHeight = `${content.scrollHeight}px`;
        }

        item.addEventListener('click', function() {
            if (this.classList.contains('active')) {
                this.classList.remove('active');
                if (content) content.style.maxHeight = null;
                return;
            }

            dropWrappers.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
                }
            });

            this.classList.add('active');
            if (content) {
                content.style.maxHeight = `${content.scrollHeight}px`;
            }
        });
    });
};


/*********************************************************************************************
 * Fonction pour splide
 */
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
    const sections = document.querySelectorAll(`[${attributeName}]`);

    sections.forEach(function (section) {
        const splideElem = section.querySelector(className);

        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            // Appel dynamique de la fonction passée en paramètre
            initializeFunction(splideElem, section); 
        }
    });
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
    let scrollCounter = 0;

    splideElem.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            return;
        }

        e.preventDefault();

        scrollCounter++;

        if (scrollCounter >= 12) {
            scrollCounter = 0;

            if (e.deltaX < 0) {
                splideInstance.go('<'); 
            } else if (e.deltaX > 0) {
                splideInstance.go('>'); 
            }
        }
    });
}


const handleFreeProductFormVariant = () => {
	document.querySelectorAll('.mm-variant').forEach(form => {
		const selector = form.querySelector('.variant-selector');
		const link = form.querySelector('.variant-link');

		if (selector && link) {
			selector.addEventListener('change', function () {
				link.setAttribute('href', this.value);
			});
		}
	});
};

// DOM ***************************************************************************************
/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener('DOMContentLoaded', () => {
    documentHeight();
    handleDropdown();
	handleFreeProductFormVariant();
});

/*********************************************************************************************
* Resized Listenner
	*
*/
window.addEventListener('resize', () => {
    documentHeight();
});